const StepButtonArrow = () => (
    <svg
        width='16'
        height='26'
        viewBox='0 0 16 26'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8.125 0H0L7.875 12.9999H16L8.125 0ZM8.125 26H0L7.875 12.9999H16L8.125 26Z'
            fill='white'
        />
    </svg>
);

export default StepButtonArrow;
